export default {
  title: {
    suffix: ' (stage)',
  },

  feature: {
    report: true,
  },
}
